// QuestBar — always visible; shows the TRACKED quest, goal-first. Clicking
// the bar opens the quest log; Claim appears only when the driver says so;
// guidance "questlog" glows the bar.

import { clear, el, kbtn } from '../kit';
import { sendBtn } from '../net';
import * as icons from '../icons';
import * as ui from '../ui';
import * as vsj from '../vsj';

export function questBar(onLogRequested: () => void): {
  root: HTMLElement;
  refresh(changed: Set<string>): void;
} {
  const iconHolder = el('div', { style: 'width:28px;height:28px;flex:none' });
  const nameLabel = el('span', { class: 'goal' });
  const stepLabel = el('span', { class: 'step', style: 'flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap' });
  const progressLabel = el('span', { class: 'k-dim' });
  const chip = el('span', { class: 'k-dim', title: 'Active quests' });
  const claimHolder = el('span');
  let iconName = '';

  const root = el(
    'div',
    { class: 'k-panel quest-bar', style: 'cursor:pointer' },
    iconHolder,
    nameLabel,
    stepLabel,
    progressLabel,
    chip,
    claimHolder,
  );
  root.addEventListener('click', (e) => {
    if ((e.target as HTMLElement).closest('button')) return;
    const tracked = vsj.at('quest_bar.tracked');
    if (tracked != null) ui.select(String(tracked));
    onLogRequested();
  });

  const rebind = () => {
    const qb = vsj.at('quest_bar') ?? {};
    const tracked = qb.tracked;
    let name = '', icon = '';
    if (tracked != null) {
      const info = vsj.info(String(tracked)) ?? {};
      name = String(info.name ?? tracked);
      icon = String(info.icon ?? tracked);
    }
    // goal-first: lead with the quest's PURPOSE (falls back to its name)
    nameLabel.textContent = qb.goal_text ? String(qb.goal_text) : name;
    stepLabel.textContent =
      tracked == null && !qb.step_text
        ? 'All quiet — explore, craft, or hunt as you like.'
        : String(qb.step_text ?? '');
    progressLabel.textContent = String(qb.progress ?? '');
    const count = Number(qb.active_count ?? 0);
    chip.style.display = count >= 2 ? '' : 'none';
    chip.textContent = `${count}⚑`;
    clear(claimHolder);
    if (qb.claim) {
      const b = kbtn(qb.claim, { label: 'Claim', cls: 'claim-pulse', clickSound: 'claim' });
      b.addEventListener('click', (e) => e.stopPropagation());
      claimHolder.append(b);
    }
    root.classList.toggle('glow', ui.glows('questlog'));
    if (icon !== iconName) {
      iconName = icon;
      clear(iconHolder);
      if (icon) iconHolder.append(icons.plated(icon, 20, 3));
    }
  };
  rebind();

  return {
    root,
    refresh(changed) {
      if (changed.has('quest_bar') || changed.has('infos') || changed.has('guidance') || changed.has('*'))
        rebind();
    },
  };
}

/** Fire the quest-bar claim btn (used by the claim modal). */
export function fireClaim(): void {
  sendBtn(vsj.at('quest_bar.claim'));
}
